import Game from "./Game";
import "./App.css";

function App() {
  return <Game />;
}

export default App;
